import type { CustomShadow } from '@mui/material/styles/experimental_extendTheme';

export const customShadow: CustomShadow = {
  primary: {
    top: '0 -16px 13px rgba(95, 143, 255, 0.5)',
    bottom: '0 16px 13px rgba(95, 143, 255, 0.5)',
    left: '-7px -8px 16px rgba(95, 143, 255, 0.3)',
    right: '7px 8px 16px rgba(95, 143, 255, 0.3)',
    center: '0 0px 13px rgba(95, 143, 255, 0.5)'
  },
  secondary: {
    top: '0 -16px 13px rgba(207, 218, 236, 0.5)',
    bottom: '0 16px 13px rgba(191, 211, 255, 0.5)',
    left: '-7px -8px 16px rgba(207, 218, 236, 0.3)',
    right: '7px 8px 16px rgba(191, 211, 255, 0.3)',
    center: '0 0px 13px rgba(191, 211, 255, 0.5)'
  },
  mobilePrimary: {
    top: '0 -8px 16px rgba(95, 143, 255, 0.15)',
    bottom: '0 4px 16px rgba(95, 143, 255, 0.15)',
    left: '-8px 0px 16px rgba(95, 143, 255, 0.15)',
    right: '8px 0px 16px rgba(95, 143, 255, 0.15)',
    center: '0 0px 16px rgba(95, 143, 255, 0.15)'
  },
  mobileSecondary: {
    top: '0 -8px 16px rgba(148, 157, 175, 0.15)',
    bottom: '0 4px 16px rgba(148, 157, 175, 0.15)',
    left: '-8px 0px 16px rgba(148, 157, 175, 0.15)',
    right: '8px 0px 16px rgba(148, 157, 175, 0.15)',
    center: '0 0px 16px rgba(148, 157, 175, 0.15)'
  }
};
